
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import { patchProject, patchProjectModule } from '@/utils/project'

const ProjectCloseDialog = Vue.extend({
    mixins: [AppMixin],
    components: { DialogTemplate },
    props: {
        props: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            testText: '',
            loading: false,
            closeError: false,
        }
    },

    computed: {
        project(): Record<string, any> {
            return this.props.project
        },
        testValid() {
            const normalize = (str: string) =>
                str.replace(/[\u200B-\u200D\uFEFF\u00A0\s]/g, '').toLowerCase()
            return normalize(this.testText) === normalize(this.project.name)
        },
        notClosedModules() {
            return this.project.modules.data.filter((module) => {
                return module.status !== 'deleted'
            })
        },
        hasNotClosedModules() {
            return this.project.modules.data.findIndex((module) => module.status !== 'deleted') > -1
        },
    },
    methods: {
        async closeProject() {
            const payload = {
                id: this.project.id,
                type: this.project.type,
                isDeleted: true,
            }

            return await patchProject(payload)
        },
        async submit() {
            if (this.testValid && this.hasNotClosedModules) {
                this.loading = true
                this.project.modules.data = await Promise.all(
                    this.project.modules.data.map(async (module) => {
                        if (module.status != 'deleted') {
                            module = await patchProjectModule(module, 'deleted').catch(() => {
                                //
                            })
                        }
                        return module
                    })
                )
                if (this.hasNotClosedModules) {
                    this.closeError = true
                } else {
                    await this.closeProject()
                    this.$emit('close', this.project)
                }

                this.loading = false
            }
        },
    },
})

export default ProjectCloseDialog
